import { ISection, IUserScheduled, TRewardType } from "../type";
import { getAuthHeaders } from "../utils/authToken";
import { apiFetch } from "../utils/apiFetch";
import { writeLessonsSectionsCache } from "../utils/lessonsSectionsCache";

export type TCurrentLessonResponse =
  | { type: "success"; sections: ISection[] }
  | { type: "error"; reason: string };

export async function getCurrentLesson(userIdForCache?: number | null): Promise<TCurrentLessonResponse> {
  const prom = new Promise<TCurrentLessonResponse>((res) => {
    apiFetch("/miniapi/get_current_lessons", {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({}),
      credentials: "include",
    })
      .then((r) => {
        if (!r.ok) {
          res({ type: "error", reason: `http_${r.status}` });
          return null;
        }
        return r.json();
      })
      .then((r) => {
        if (!r) return;
        const sections: ISection[] = Array.isArray(r?.Sections)
          ? (r.Sections as ISection[])
          : [];

        if (sections.length === 0) {
          res({ type: "success", sections: [] });
          return;
        }

        sections.sort((a, b) => {
          return a.sequence_number__section - b.sequence_number__section;
        });

        sections.forEach((s) => {
          if (!Array.isArray(s.Lesson_SectionRelation)) return;
          s.Lesson_SectionRelation.sort(
            (a, b) => a.sequence_number__lesson - b.sequence_number__lesson
          );
          if (s.Lesson_SectionRelation.length !== 21)
            console.error(
              "Wrong amount of lessons in section. Section id: " +
                s.id +
                " count lessons: " +
                s.Lesson_SectionRelation.length
            );
          s.Lesson_SectionRelation.forEach((l) => {
            if (Array.isArray(l.Exercise_LessonRelation)) {
              l.Exercise_LessonRelation.sort((a, b) => a.order - b.order);
            }
          });
        });
        var x = new Date();
        var h = x.getTimezoneOffset() / 60 - 3; //колво часов от мск
        const user_sh_s: IUserScheduled[] = Array.isArray(r?.UserLessonsScheduled)
          ? (r.UserLessonsScheduled as IUserScheduled[])
          : [];
        for (let i = 0; i < user_sh_s.length; i++) {
          const d = new Date(user_sh_s[i].start_date);
          d.setHours(d.getHours() - h);
          user_sh_s[i].start_date = d.toJSON();
        }
        sections.forEach((s) => {
          s.UserLessonsScheduled = user_sh_s.filter((us) => us.SectionId === s.id);
        });
        // Heavy debug logs with full sections payload noticeably slow down
        // initial render on weak devices; keep them out of production flow.

        if (userIdForCache != null && Number.isFinite(userIdForCache) && userIdForCache > 0) {
          writeLessonsSectionsCache(userIdForCache, sections);
        }
        res({ type: "success", sections: sections });
      })
      .catch((e) => {
        const msg = e && typeof e === "object" && "message" in e ? String((e as Error).message) : "network_error";
        res({ type: "error", reason: msg });
      });
  });

  return await prom;
}

export type TcompleteExerciseResponse = {
  type: "success";
  addCoin: TRewardType;
  value: number;
};

export async function completeExercise(
  exercises_id: number,
  passed?: boolean,
  answer?: string
): Promise<TcompleteExerciseResponse> {
  const r = await apiFetch("/miniapi/complete_exercise", {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({
      exercises_id: exercises_id,
      passed: passed,
      answer: answer,
    }),
    credentials: "include",
  });
  if (!r.ok) {
    const text = await r.text().catch(() => "");
    throw new Error(`complete_exercise_http_${r.status}: ${text.slice(0, 200)}`);
  }
  const data = await r.json();
  // Определяем значение награды
  let value = 1; // По умолчанию
  if (data.addCoin === "Silver" && data.Achievements?.Silver) {
    value = data.Achievements.Silver;
  } else if (data.addCoin === "Gold" && data.Achievements?.Gold) {
    value = data.Achievements.Gold;
  } else if (data.addCoin === "Pearl" && data.Achievements?.Pearl) {
    value = data.Achievements.Pearl;
  }
  return { type: "success", addCoin: data.addCoin, value };
}

export type TcompleteExerciseLoadFile = {
  type: "success";
};

export async function requestExerciseLoadFile(
  exercises_id: number
): Promise<TcompleteExerciseLoadFile> {
  const prom = new Promise<TcompleteExerciseLoadFile>((res) => {
    fetch("/api/sendFile", {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({
        exercises_id: exercises_id,
      }),
      credentials: "include",
    }).then((r) => {
      res({ type: "success" });
    });
  });

  return await prom;
}

export async function withDrawalSilver(
  scheduled_id: number,
  lesson_id: number
): Promise<TcompleteExerciseLoadFile> {
  const prom = new Promise<TcompleteExerciseLoadFile>((res) => {
    apiFetch("/miniapi/withdrawal_silver", {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({
        sdt: scheduled_id,
        lesson_id: lesson_id,
      }),
      credentials: "include",
    }).then((r) => {
      res({ type: "success" });
    });
  });

  return await prom;
}
